export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/google-play-badge-white.dc4dd46a.svg","height":48,"width":129};